import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: "",
  data: [],
  clinicInfo: {},
  page: 0,
  has_next: false,
  has_prev: false,
  total_pages: 0,
  total_results: 0,
}

const businessSlice = createSlice({
  name: 'businessSlice',
  initialState: initialState,
  reducers: {
    setLoading: (state, action) => {
      return {...state, loading: action.payload, error: ''};
    },

    setSuccess: (state, action) => {
      return {...state, success: true, loading: false, error: ''}

    },
    setClinics: (state, action) => {
      return {
        ...state, loading: false,
        has_next: action.payload.has_next,
        has_prev: action.payload.has_prev,
        total_pages: action.payload.total_pages,
        total_results: action.payload.total_results,
        page: action.payload.page,
        data: action.payload.data,
        error: ''
      };
    },

    getClinics: (state, action) => {
    },


    setClinicStatus: (state, action) => {
    },

    setUpdateStatusIndex: (state, action) => {
      return {
        ...state,
        loading: false,
        data: [...state.data].map((clinic, index) => {
          if (index === action.payload.index) {
            return {
              ...clinic,
              status: action.payload.status === 'DOCUMENT_VERIFIED' ? 'ACTIVE' : action.payload.status
            }
          } else {
            return clinic
          }
        }),
      }
    },
    setClinicInfo: (state, action) => {
      return {
        ...state,
        loading: false,
        clinicInfo: action.payload,
        error: '',
      }
    },

    getClinicInfo: () => {
    },


    setError: (state, action) => {
      return {...state, error: action.payload, loading: false};
    }
  }

})

export const {
  setLoading,
  setSuccess,
  setError,
  setClinics,
  getClinics, setClinicStatus, setUpdateStatusIndex, setClinicInfo, getClinicInfo
} = businessSlice.actions;
export default businessSlice.reducer;